// source: proto/messages/ali_sts.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.proto.messages.AliSTSCredentials', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.messages.AliSTSCredentials = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.messages.AliSTSCredentials, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.messages.AliSTSCredentials.displayName = 'proto.proto.messages.AliSTSCredentials';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.messages.AliSTSCredentials.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.messages.AliSTSCredentials.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.messages.AliSTSCredentials} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.AliSTSCredentials.toObject = function(includeInstance, msg) {
  var f, obj = {
    accesskeysecret: jspb.Message.getFieldWithDefault(msg, 1, ""),
    expiration: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accesskeyid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    securitytoken: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.messages.AliSTSCredentials}
 */
proto.proto.messages.AliSTSCredentials.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.messages.AliSTSCredentials;
  return proto.proto.messages.AliSTSCredentials.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.messages.AliSTSCredentials} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.messages.AliSTSCredentials}
 */
proto.proto.messages.AliSTSCredentials.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccesskeysecret(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpiration(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccesskeyid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecuritytoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.messages.AliSTSCredentials.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.messages.AliSTSCredentials.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.messages.AliSTSCredentials} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.AliSTSCredentials.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccesskeysecret();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpiration();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccesskeyid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSecuritytoken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string accessKeySecret = 1;
 * @return {string}
 */
proto.proto.messages.AliSTSCredentials.prototype.getAccesskeysecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.AliSTSCredentials} returns this
 */
proto.proto.messages.AliSTSCredentials.prototype.setAccesskeysecret = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string expiration = 2;
 * @return {string}
 */
proto.proto.messages.AliSTSCredentials.prototype.getExpiration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.AliSTSCredentials} returns this
 */
proto.proto.messages.AliSTSCredentials.prototype.setExpiration = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string accessKeyId = 3;
 * @return {string}
 */
proto.proto.messages.AliSTSCredentials.prototype.getAccesskeyid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.AliSTSCredentials} returns this
 */
proto.proto.messages.AliSTSCredentials.prototype.setAccesskeyid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string securityToken = 4;
 * @return {string}
 */
proto.proto.messages.AliSTSCredentials.prototype.getSecuritytoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.AliSTSCredentials} returns this
 */
proto.proto.messages.AliSTSCredentials.prototype.setSecuritytoken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


goog.object.extend(exports, proto.proto.messages);
